/** Explicit academic intent is separate from tone, graph lanes and passive adaptation.
 * Classification is trusted server input established from maintained persistence bindings;
 * member titles/tags and publisher identity alone never classify a post. */
export const DISCOVERY_POLICY_VERSION = 'learning-discovery-1.0.0';
export const CONTENT_SCOPES = Object.freeze(['ordinary', 'learning']);

/** Unavailable maintained bindings fail closed on every discovery surface. Latest,
 * Following and nonempty search express intent without silently opting into Learning.
 * All other ordinary recommendations exclude educational readings for their full length. */
export function learningDiscoveryAllows(
  classification,
  { contentScope = 'ordinary', mode, scope, explicitSearch = false, academicAnchor = false } = {},
) {
  if (!CONTENT_SCOPES.includes(contentScope)) throw new RangeError('Invalid content scope');
  if (classification === 'unavailable') return false;
  if (contentScope === 'learning') return classification === 'educational';
  return (
    classification !== 'educational' ||
    mode === 'latest' ||
    scope === 'following' ||
    explicitSearch ||
    academicAnchor
  );
}
